import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QuicklinkStrategy } from 'ngx-quicklink';
import { AppModule } from './app.module';
import { DefaultLayoutComponent } from './layouts/default-layout/default-layout.component';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { LoginComponent } from './pages/authentication/login/login.component';
import { RegisterComponent } from './pages/authentication/register/register.component';
import { ResetPasswordComponent } from './pages/authentication/reset-password/reset-password.component';
import { VerifyEmailComponent } from './pages/authentication/verify-email/verify-email.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ErrorPageNotFoundComponent } from './pages/not-found/not-found.component';
import { UnauthorizeComponent } from './pages/Unauthorize/Unauthorize.component';
import { AuthGuardLoginService } from './services/auth-guard-login.service';
import { AuthGuardService } from './services/auth-guard.service';
import { ViewLayoutComponent } from './layouts/view-layout/view-layout.component';
import { TramdoDetailComponent } from './pages/tramdo-detail/tramdo-detail.component';
import { MapviewComponent } from './pages/mapview/mapview.component';
import { TramdoReportComponent } from './pages/tramdo-report/tramdo-report.component';
import { HomeComponent } from './pages/home/home.component';
import { ProfileComponent } from './pages/profile/profile.component';

const routes: Routes = [
  {
    path: '', component: ViewLayoutComponent,
    children: [
      { path: '', component: HomeComponent },
      { path: 'tramdo', component: DashboardComponent },
      { path: 'bieudo', component: TramdoDetailComponent },
      { path: 'bieudo/:id', component: TramdoDetailComponent },
      { path: 'baocao', component: TramdoReportComponent },
      { path: 'baocao/:id', component: TramdoReportComponent },
      { path: 'bando', component: MapviewComponent },
      { path: 'bando/:id', component: MapviewComponent },
      { path: 'profile', component: ProfileComponent },
      {
        path: 'error/404',
        component: ErrorPageNotFoundComponent
      }
    ],
    canActivate: [AuthGuardService]
  },
  {
    path: 'admin', component: DefaultLayoutComponent,
    children: [
      { path: 'core', loadChildren: () => import('./sv-core/sv-core.module').then(m => m.SvCoreModule) },
      { path: 'thmp', loadChildren: () => import('./thmp-monitoring/thmp-monitoring.module').then(m => m.ThmpMonitoringModule) },
    ],
  },
  {
    path: 'authentication',
    component: LoginLayoutComponent,
    children: [
      { path: 'signin', component: LoginComponent },
      { path: 'reset-password/:instanceId/:code', component: ResetPasswordComponent },
      { path: 'signup', component: RegisterComponent },
      { path: 'verify/:instanceId/:code', component: VerifyEmailComponent }
    ],
    canActivate: [AuthGuardLoginService]
  },
  {
    path: 'unauthorize',
    component: UnauthorizeComponent
  },
  {
    path: '**',
    redirectTo: 'error/404'
  }
];


export const AppRoutes: ModuleWithProviders<AppModule> = RouterModule.forRoot(routes, { preloadingStrategy: QuicklinkStrategy });
